import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Dialog, Form, Input, MessagePlugin, Textarea } from 'tdesign-react';
import { saveFlowGroup, updateFlowGroup } from '@/services/templateService';

const { FormItem } = Form;

export default function FormModal({ handleClose, visible, detail }) {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const [submitting, setSubmitting] = useState(false);

  const id = searchParams.get('id');
  const isEdit = !isEmpty(detail);

  useEffect(() => {
    if (visible && isEdit) {
      form.setFieldsValue(detail);
    }

    if (!visible) {
      form.reset();
    }
  }, [visible, form, detail, isEdit]);

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      try {
        setSubmitting(true);
        if (isEdit) {
          await updateFlowGroup({
            ...detail,
            ...fields,
          });
        } else {
          await saveFlowGroup({
            ...fields,
            flowBaseId: id,
          });
        }
        MessagePlugin.success('操作成功');
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Dialog
      onClose={() => handleClose()}
      visible={visible}
      header={isEdit ? '修改主机组' : '新建主机组'}
      confirmBtn={{
        loading: submitting,
        content: '确认',
      }}
      onConfirm={() => form.submit()}
    >
      <Form style={{ width: '90%' }} labelWidth={140} form={form} onSubmit={handleSubmit}>
        <FormItem name='name' label='主机组名称' rules={[{ required: true }]}>
          <Input />
        </FormItem>
        <FormItem name='explains' label='主机组显示说明' rules={[{ required: true }]}>
          <Input />
        </FormItem>
        <FormItem name='notes' label='备注'>
          <Textarea />
        </FormItem>
      </Form>
    </Dialog>
  );
}
